import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CityProvider } from './context/CityContext';
import { NotificationsProvider } from './context/NotificationsContext';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Landing from './pages/Landing/Landing';
import CityPortal from './pages/CityPortal/CityPortal';
import MyAlerts from './pages/MyAlerts/MyAlerts';
import AdminConfig from './pages/AdminConfig/AdminConfig';
import './App.css';

function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '5rem 1rem' }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>404</div>
      <h2 style={{ color: '#1a202c', marginBottom: '0.5rem' }}>Page not found</h2>
      <a href="/" style={{ color: '#3182ce', fontWeight: 600 }}>← Go home</a>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <CityProvider>
        <NotificationsProvider>
          <div className="app-shell">
            <Header />
            <main className="app-main">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/admin" element={<AdminConfig />} />
                <Route path="/:citySlug" element={<CityPortal />} />
                <Route path="/:citySlug/my-alerts" element={<MyAlerts />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </NotificationsProvider>
      </CityProvider>
    </BrowserRouter>
  );
}
